export default __webpack_public_path__ + "images/5b99a741bef76616dd0e69483f14e5d3-kayaking.webp";